import { pxToRem } from '@/shared/styles/themes'
import { Paper, styled } from '@mui/material'

export const StyledTooltipPaper = styled(Paper)`
  min-width: ${pxToRem(300)};
  padding: ${pxToRem(8)};
  display: flex;
  flex-direction: column;
  gap: ${pxToRem(8)};
`